import { useGetUserIdFromParams } from './use-get-user-id-from-params';
import { useProfileDataQuery } from './use-profile-data-query';

export const useIsMyProfile = () => {
  const { data } = useProfileDataQuery();
  const userIdFromParams = useGetUserIdFromParams();

  return (data && typeof data.id !== 'undefined' && data.id === userIdFromParams) || false;
};
